import {createTypes, async} from 'redux-action-creator'

export default createTypes(
  [
    ...async('SELECT_CATEGORY'),
    ...async('FETCH_FIRST_LEVEL_CATEGORIES'),
    'DESELECT_CATEGORY',
  ],
  'COMMUNITY/CATEGORY_LIST/',
)



// WEBPACK FOOTER //
// ./src/sections/community/types/categoryList.js